export function isDoctrinePdfAuthenticationError(error) {
  const status = Number(
    error?.status
    ?? error?.statusCode
    ?? error?.response?.status,
  );
  if (status === 401) return true;

  const message = String(error?.message || error || "");
  return /(?:\(401\)|\bstatus(?: code)?\s*401\b|authentication_required|necesit[aá]s iniciar sesi[oó]n)/i
    .test(message);
}

export function doctrinePdfErrorMessage(error, fallback) {
  if (isDoctrinePdfAuthenticationError(error)) {
    return "Tu sesión venció y no pudimos renovarla automáticamente.";
  }
  return error?.message || fallback;
}
